module.exports = __webpack_public_path__ + "static/media/paint.0051563c.jpg";